export interface CacheItem {
    time: Number
    response: any
}

export function CreateCacheItem(response: any) {
    return {
        time: new Date().getDate(),
        response
    } as CacheItem
}